"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PricingAndPurchase = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _priceBlock = require("@site/price-block");
var _utils = require("@site/utils");
var _buttons = require("@site/buttons");
var _PremiumSupportPhone = _interopRequireDefault(require("../PremiumSupportPhone"));
/* eslint-disable complexity */

const ConditionalWrapper = ({
  condition,
  wrapper,
  isLeaseToOwnEnabled,
  isAnnualTermMonthlyPrice,
  children
}) => condition ? wrapper({
  isLeaseToOwnEnabled,
  children,
  isAnnualTermMonthlyPrice
}) : children;
ConditionalWrapper.propTypes = {
  condition: _propTypes.default.bool,
  wrapper: _propTypes.default.func,
  isLeaseToOwnEnabled: _propTypes.default.bool,
  isAnnualTermMonthlyPrice: _propTypes.default.bool,
  children: _propTypes.default.node
};
const MobileWrapper = ({
  isLeaseToOwnEnabled,
  children,
  isAnnualTermMonthlyPrice
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: (0, _classnames.default)('d-flex justify-content-between mt-3', {
    'flex-column justify-content-end': isLeaseToOwnEnabled || isAnnualTermMonthlyPrice,
    'flex-row align-items-end': !isLeaseToOwnEnabled
  })
}, children);
MobileWrapper.propTypes = {
  isLeaseToOwnEnabled: _propTypes.default.bool,
  children: _propTypes.default.node,
  isAnnualTermMonthlyPrice: _propTypes.default.bool
};
const EstimateValueMobileWrapper = ({
  children
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: "d-flex flex-column"
}, children);
EstimateValueMobileWrapper.propTypes = {
  children: _propTypes.default.node
};
const PricingAndPurchase = ({
  isAuctionDomain,
  isAftermarketPremiumDomain,
  privateLabelId,
  showEstimatedValue,
  availableDomain,
  availableDomainProduct,
  buttonProps = {},
  useBlackAtcButton,
  deviceType,
  displayPercentagePrice,
  infoTextId,
  styleOverrides,
  dataCy,
  AddToCartButton = _buttons.AvailableAddToCartButton,
  language,
  termsPricingOptions = {},
  auctionPhone,
  premiumPhone,
  isStackBundle,
  bundleProduct,
  apiKey
}) => {
  const {
    isMobile,
    isDesktop,
    isTablet
  } = deviceType;
  const market = (0, _utils.getMarket)();
  const currency = (0, _utils.getCurrency)();
  const buyButtonClassNames = (0, _classnames.default)('px-4', {
    'button-primary-teal': !useBlackAtcButton,
    'pl-5 pr-5': Object.keys(buttonProps).length && isDesktop,
    [buttonProps?.buyButtonClassNames]: buttonProps?.buyButtonClassNames
  });
  const options = {
    displayPercentagePrice
  };
  const {
    showTermsPricing,
    displayMonthlyPricing,
    showMonthlyPriceDisclaimer,
    hideListPrice,
    showFreeIndicator
  } = termsPricingOptions;
  const {
    aftermarketPremiumPricingDisplay,
    monthlyPricingDisplay,
    annualPricingDisplay,
    terms,
    samePriceEachYear,
    isPriceConsistent
  } = (0, _utils.getDomainPriceInfo)({
    domain: availableDomain,
    product: availableDomainProduct,
    market,
    currency
  });
  const termLength = terms?.promoRegLengthFlag || 2;
  const promoLength = terms?.promoRegLengthFlag;
  const hasMultiYearTerm = promoLength > 1;
  const standardTermsPricingProps = {
    hasMultiYearTerm,
    isMobile,
    termLength,
    annualPricingDisplay,
    monthlyPricingDisplay,
    displayMonthlyPricing,
    showMonthlyPriceDisclaimer,
    hideListPrice,
    isPremiumPrice: isAftermarketPremiumDomain || isAuctionDomain,
    samePriceEachYear,
    isPriceConsistent,
    aftermarketPremiumPricingDisplay,
    styleOverrides,
    showFreeIndicator,
    privateLabelId
  };
  return /*#__PURE__*/_react.default.createElement(ConditionalWrapper, {
    condition: isMobile,
    wrapper: MobileWrapper,
    isLeaseToOwnEnabled: false,
    isAnnualTermMonthlyPrice: false
  }, /*#__PURE__*/_react.default.createElement(ConditionalWrapper, {
    condition: isMobile && showEstimatedValue,
    wrapper: EstimateValueMobileWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      'd-flex flex-column ms-2': isMobile
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex d-flex-row"
  }, showTermsPricing ? /*#__PURE__*/_react.default.createElement(_priceBlock.StandardTermsPricing, standardTermsPricingProps) : /*#__PURE__*/_react.default.createElement(_priceBlock.ExactMatchPriceBlock, {
    domain: availableDomain,
    product: availableDomainProduct,
    isStackBundle: isStackBundle,
    isTwoCardLayout: true,
    options: options,
    privateLabelId: privateLabelId,
    language: language
  })), !isMobile && infoTextId && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      'text-muted': !styleOverrides?.disclaimerStyle?.color && (0, _utils.isReseller)(privateLabelId)
    }),
    style: styleOverrides?.disclaimerStyle,
    "data-cy": `${dataCy}-info-text`
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: infoTextId
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      'my-auto': isMobile,
      'flex-grow-1 mt-3': !isMobile
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex w-100 align-items-center"
  }, isStackBundle ? /*#__PURE__*/_react.default.createElement(_buttons.BundleAddToCartButton, (0, _extends2.default)({
    apiKey: apiKey,
    buttonClassNameOverride: buyButtonClassNames,
    domain: availableDomain,
    plid: String(privateLabelId),
    product: {
      name: bundleProduct
    },
    version: 2
  }, buttonProps)) : /*#__PURE__*/_react.default.createElement(AddToCartButton, (0, _extends2.default)({
    domain: availableDomain,
    product: availableDomainProduct,
    plid: privateLabelId,
    buttonClassNameOverride: buyButtonClassNames
  }, buttonProps)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      'd-flex flex-column align-items-center pt-2': isMobile,
      'mt-1': isTablet,
      'align-items-center': isDesktop
    })
  }, /*#__PURE__*/_react.default.createElement(_PremiumSupportPhone.default, {
    isAuctionDomain: isAuctionDomain,
    cssClasses: 'text-muted ms-1 pl-2',
    auctionPhone: auctionPhone,
    premiumPhone: premiumPhone
  })))));
};
exports.PricingAndPurchase = PricingAndPurchase;
PricingAndPurchase.propTypes = {
  regularBundleResult: _propTypes.default.object,
  qualifiersTextId: _propTypes.default.string,
  infoTextId: _propTypes.default.string,
  showEstimatedValue: _propTypes.default.bool,
  availableDomain: _propTypes.default.object,
  availableDomainProduct: _propTypes.default.object,
  styleOverrides: _propTypes.default.shape({
    priceContainer: _propTypes.default.string,
    isInline: _propTypes.default.bool,
    mainPriceStyle: _propTypes.default.object,
    strikethroughPriceStyle: _propTypes.default.object,
    disclaimerStyle: _propTypes.default.object
  }),
  buttonProps: _propTypes.default.shape({
    addToCartText: _propTypes.default.string,
    verifyingText: _propTypes.default.string,
    removeFromCartText: _propTypes.default.string,
    removingFromCartText: _propTypes.default.string,
    buyButtonClassNames: _propTypes.default.string
  }),
  useBlackAtcButton: _propTypes.default.bool,
  deviceType: _propTypes.default.object.isRequired,
  displayPercentagePrice: _propTypes.default.bool,
  isLeaseToOwnEnabled: _propTypes.default.bool,
  privateLabelId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  AddToCartButton: _propTypes.default.func,
  dataCy: _propTypes.default.string,
  language: _propTypes.default.object,
  auctionPhone: _propTypes.default.string,
  premiumPhone: _propTypes.default.string,
  isStackBundle: _propTypes.default.bool,
  bundleProduct: _propTypes.default.string,
  apiKey: _propTypes.default.string
};